import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class RemoveItemFromFavoritesAPICall extends APICallV4 {
    _method = 'album/element/favorite/unset';
    _type: Method = 'post';
}
